import { Spec, Options } from '@oms/jaws-react';
export const generateSpec = (itemSector?: string) => {
  const getConditionalParams = () => {
    if (itemSector) {
      const [ITEM, SECTOR = 'ose'] = itemSector?.split('.') || [];
      return {
        filter: `ITEM==s${ITEM}&&SEARCH_HISTORY==n1&&DIVIDEND!=n0`,
        source: `feed.${SECTOR.toLowerCase()}.ca.dividend.EQUITIES_ALL`,
      };
    }

    return {
      filter: 'SEARCH_HISTORY==n1&&DIVIDEND!=n0',
      generators: [
        { source: 'feed.ose.ca.dividend.EQUITIES_ALL' },
        { source: 'feed.merk.ca.dividend.EQUITIES_ALL' },
        { source: 'feed.oax.ca.dividend.EQUITIES_ALL' },
      ],
    };
  };

  return {
    type: 'history',
    columns: 'TIME, EVENT_DATE, ITEM, CURRENCY, DIVIDEND, DIVIDEND_IN_CURRENCY',
    space: 'DAY',
    ranking: '-EVENT_DATE',
    limit: 10,
    ...getConditionalParams(),
  };
};

export interface DividendsProps {
  /** A spec to override the default values of the component. */
  spec?: Spec & {
    /** The source to fetch data from, default is feed.{sector}.ca.dividend.EQUITIES_ALL,
     * And if no itemSector is specified uses generator-query with:
     * feed.ose.ca.dividend.EQUITIES_ALL
     * feed.merk.ca.dividend.EQUITIES_ALL
     * feed.oax.ca.dividend.EQUITIES_ALL
     * */
    source?: string;
    /** The number of rows in the table. _Default: 10_ */
    limit?: number;
  };
  /** Will be passed to the `<table>` */
  className?: string;
  /** Disables the loading indicator */
  disableLoading?: boolean;
  /** Which instrument  */
  itemSector?: string;
}

export interface UseDividendsArguments {
  spec?: Spec;
  options?: Options;
  itemSector?: string;
}

type Item = { TIME?: number; EVENT_DATE?: string };
export const sortByTimeDsc = (a: Item, b: Item) => {
  if (b?.TIME && a?.TIME && a.TIME !== b.TIME) {
    return b.TIME - a.TIME;
  }

  if (b?.EVENT_DATE && a?.EVENT_DATE) {
    return b.EVENT_DATE.localeCompare(a.EVENT_DATE);
  }

  return 0;
};
